export default (value) => {
  const pattern = /^\d{12}$/;
  return value ? pattern.test(value.toString()) : true;
};
